import { render, staticRenderFns } from "./VerDetalleCuadratura.vue?vue&type=template&id=68a5dbf5&"
import script from "./VerDetalleCuadratura.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleCuadratura.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleCuadratura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68a5dbf5', component.options)
    } else {
      api.reload('68a5dbf5', component.options)
    }
    module.hot.accept("./VerDetalleCuadratura.vue?vue&type=template&id=68a5dbf5&", function () {
      api.rerender('68a5dbf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/VerDetalleCuadratura.vue"
export default component.exports